import React from "react";
import { Popover, Button } from "antd";
import { observer } from "mobx-react";
import { DateRangePicker } from "../../dateRangePicker/DateRangePicker";
import { translateKey as t } from "../../../locales/translation";
import { observable } from "mobx";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);
@observer
export class DateRangeFilter extends React.PureComponent<{
  column: any;
  handleFilter?: any;
  showTimePicker?: boolean;
}> {
  @observable private isMenuShowing = false;

  private renderPopoverTitle = () => {
    return (
      <Button
        size="small"
        disabled={!this.props.column.filterValue}
        onClick={() => {
          this.props.column.filterValue = "";
          this.props.handleFilter(this.props.column, "");
          this.isMenuShowing = false;
        }}
      >
        {t("lblReset", "Reset")}
      </Button>
    );
  };

  private handleDateSelection = (dates) => {
    this.props.column.filterValue = dates;

    if (!this.props.column.filterOnSubmit) {
      this.props.column.finalFilterValue = dates;
      this.isMenuShowing = false;
    }
  };

  public render() {
    const { column } = this.props;

    return (
      <Popover
        placement="bottom"
        open={this.isMenuShowing}
        onOpenChange={(value) => (this.isMenuShowing = value)}
        title={this.renderPopoverTitle()}
        content={
          <div style={{ margin: "-12px -16px" }}>
            <DateRangePicker
              values={column.filterValue}
              onSelection={this.handleDateSelection}
              showTimePicker={{ show: this.props.showTimePicker, toISOString: true }}
            />
            {column.filterOnSubmit && (
              <div style={{ margin: "0 15px 15px 0", textAlign: "right" }}>
                <Button
                  size="small"
                  type="primary"
                  disabled={!column.filterValue && !column.finalFilterValue}
                  onClick={() => {
                    this.props.handleFilter(column, "date");
                    this.isMenuShowing = false;
                  }}
                >
                  {t("lblApply", "Apply")}
                </Button>
              </div>
            )}
          </div>
        }
        trigger="click"
        overlayStyle={{ maxWidth: 273 }}
      >
        <Button size="small" style={{ width: "100%" }}>
          {column.filterValue ? (
            <FontAwesomeIcon icon={faFilter} style={{ color: "#1890ff" }} />
          ) : (
            <FontAwesomeIcon icon={faFilter} />
          )}
        </Button>
      </Popover>
    );
  }
}

const FilteringMethod = (value, query, format) => {
  if (query.length === 2) {
    const dateFormat = format ? format : "YYYY-MM-DD";

    if (dayjs(query[0]).isSame(query[1])) {
      return dayjs(value, dateFormat).isSame(query[0], "day");
    }

    return dayjs(value, dateFormat).isBetween(query[0], query[1], "dates", "[]");
  }

  return false;
};

export { FilteringMethod };
